"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HistoryListener = void 0;
var PushStateEvent = 'pushState';
var ReplaceStateEvent = 'replaceState';
function injectHistoryFunction(eventType) {
  var originalFunction = window.history[eventType];
  var event = new Event(eventType);
  window.history[eventType] = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var res = originalFunction.apply(window.history, args);
    // 先执行方法，更新location后再触发callback
    window.dispatchEvent(event);
    return res;
  };
}
var historyEventList = ['replaceState', 'pushState', 'popstate', 'hashchange', 'beforeunload'];
var HistoryListener = /** @class */function () {
  function HistoryListener() {}
  HistoryListener.dispatchEvent = function (eventType) {
    try {
      for (var _i = 0, _a = Object.values(HistoryListener.listenerMap); _i < _a.length; _i++) {
        var handler = _a[_i];
        handler(eventType);
      }
    } catch (error) {
      //
    }
  };
  HistoryListener.prototype.init = function () {
    if (HistoryListener.filled) {
      return;
    }
    try {
      injectHistoryFunction(PushStateEvent);
      injectHistoryFunction(ReplaceStateEvent);
      var _loop_1 = function _loop_1(eventType) {
        window.addEventListener(eventType, function () {
          HistoryListener.dispatchEvent(eventType);
        });
      };
      for (var _i = 0, historyEventList_1 = historyEventList; _i < historyEventList_1.length; _i++) {
        var eventType = historyEventList_1[_i];
        _loop_1(eventType);
      }
      HistoryListener.filled = true;
    } catch (error) {
      //
    }
  };
  HistoryListener.prototype.add = function (app_name, handler) {
    HistoryListener.listenerMap[app_name] = handler;
    this.init();
  };
  HistoryListener.prototype.remove = function (app_name) {
    if (HistoryListener.listenerMap[app_name]) {
      delete HistoryListener.listenerMap[app_name];
    }
  };
  HistoryListener.listenerMap = {};
  HistoryListener.filled = false;
  return HistoryListener;
}();
exports.HistoryListener = HistoryListener;